import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { Router } from '@angular/router';
import { SocialCapitalModel } from './social-capital.model';
import { SocialCapitalService } from './social-capital.service';
import { SocialCapitalConst } from './const';
import { SocialCapitalFormComponent } from './social-capital-form.component';
import { SocialCapitalDeleteComponent } from './social-capital-delete.component';
import { AccountingAccountsDialogLedgerComponent } from '../../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';
import { AccountingAccountsService } from '../../../accounting/accounting-accounts/accounting-accounts.service';
import { Utils } from '../../../../shared/utils';
import * as FileSaver from 'file-saver';
import { consts } from '../../../../consts';

@Component({
    selector: 'app-social-capital-list',
    templateUrl: './social-capital-list.component.html',
    styleUrls: ['./social-capital-list.component.css'],
    standalone: false
})
export class SocialCapitalListComponent implements OnInit {


  ready = false;
  empty: boolean = true;
  headerTable: any[] = SocialCapitalConst.headerTable;
  dataSource: SocialCapitalModel[] = [];

  constructor(
    public SocialCapitalService: SocialCapitalService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private router: Router,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
  ) { }

  public ngOnInit() {
    this.SocialCapitalService.getList().then(
      data => {
        this.dataSource = data;
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  public create(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(SocialCapitalFormComponent, {
      width: '520px', maxWidth: '96vw',
      data: { uid: uid },
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public edit(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(SocialCapitalFormComponent, {
      width: '520px', maxWidth: '96vw',
      data: { uid: uid },
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public delete(uid: number) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(SocialCapitalDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public mayor(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    this.dialog.open(AccountingAccountsDialogLedgerComponent, {
      width: '700px',
      maxWidth: '96vw',
      
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        id: searchedElement.accountingModelsId,
        name: undefined,
        number: searchedElement.accountingModelsNumber,
      }
    });
  }

  public extracto(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    this.accountingAccountsService.excelExtractoContable(searchedElement.accountingModelsId.toString())
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName("Extracto contable"));
      }).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');

      });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
